import { render, staticRenderFns } from "./PsAvatar.vue?vue&type=template&id=cad39912&scoped=true&"
import script from "./PsAvatar.vue?vue&type=script&lang=js&"
export * from "./PsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PsAvatar.vue?vue&type=style&index=0&id=cad39912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad39912",
  null
  
)

export default component.exports